import gql from "graphql-tag"

const GENERATE_SCREENSHOT_METADATA_FIELD = gql`
  mutation generateScreenshotMetadataField(
    $generateScreenshotMetadataFieldInput: GenerateScreenshotMetadataFieldInput!
  ) {
    generateScreenshotMetadataField(
      generateScreenshotMetadataFieldInput: $generateScreenshotMetadataFieldInput
    ) {
      field
      value
    }
  }
`

export default GENERATE_SCREENSHOT_METADATA_FIELD
